module.exports = __webpack_public_path__ + "img/account-icon.8e231307.svg";